const React = require('react');
const {object, string} = require("yup");
const {FormWrapper, FormFooter} = require('../../../../../../../dumb/FormHandlers');
const {AdminSelect} = require("../../../../../../../dumb/FormInputs");

const {apiAdminMerchantActivate} = require("../../../../../../../../api/admin/retailersCreate");

const {pushLocation} = require("../../../../../../../../router");
const {getAdminRetailersLink} = require("../../../../../../../../utils/adminLinkCtor");


module.exports = ({account_id, close}) => {
  return (
    <FormWrapper
      schema={{default: object({entity_id: string().required()})}}
      onSubmit={(props) => (
        apiAdminMerchantActivate({account_id, ...props})
      )}
      onResult={({account_id}) => {
        pushLocation({
          path: getAdminRetailersLink(account_id)
        });
        close();
      }}
    >{(formCtx) => {
        return (
          <>
            <div className="mt28">
              <AdminSelect
                propName="name"
                propValue="id"
                items={[
                  {id: 'lunu_uab_europe', name: 'Lunu UAB Europe (Lithuania)'},
                  {id: 'web3_solutions_srl', name: 'Web3 Solutions Srl (Italy)'}
                ]}

                name="entity_id"
                label="Lunu Legal Entity"
                formCtx={formCtx}
              />
            </div>
            <FormFooter
              submitBtnData={{
                text: 'Activate Retailer',
                testId: 'activateRetailer',
                formCtx
              }}
              additionalBtnsList={[
                {text: 'Cancel', onClick: close},
              ]}
            />
          </>
        )
    }}</FormWrapper>
  )
}
